export enum ErrorMessages {
  INPUT_ERROR = "Double check your information and try again, if the problem persists contact support@tryfi.com",
  DEFAULT = "Reload the page and try again, if the problem persists contact support@tryfi.com"
}
export default ErrorMessages;
